module.exports = require('./helpers/bundle-url').getBundleURL('c30iu') + "logo-dark.eefe0b7f.svg";